import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, Heading, Text, Input } from '../../Elements/Elements';

import classes from './InputArea.module.scss';

const InputArea = ({
  value,
  onChange,
  placeholder,
  onClearSearch,
  iconSearch = true,
  percentMode = true,
  title,
  maxLength,
  visibleCounter = true,
  modeTextArea = false,
  required = false,
  clearButton = true,
  classNameScheme
}) => {
  const handleInput = e => {
    if (maxLength) {
      if (e.target.value.length <= maxLength) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return (
    <>
      {title && (
        <Heading
          className={cn(
            classes.title,
            classNameScheme && classNameScheme.title
          )}
        >
          {title}
        </Heading>
      )}
      <div
        className={cn(
          classes.search,
          percentMode && classes.search_percent,
          classNameScheme && classNameScheme.wrap
        )}
      >
        {!modeTextArea ? (
          <Input
            input={{
              value: value,
              onChange: handleInput
            }}
            placeholder={placeholder}
            className={cn(
              classes.search_input,
              classNameScheme && classNameScheme.input
            )}
            required={required}
          />
        ) : (
          <textarea
            className={cn(
              classes.text,
              classNameScheme && classNameScheme.input
            )}
            onChange={handleInput}
            placeholder={placeholder}
            required={required}
            value={value}
          />
        )}
        {value && clearButton && (
          <div
            className={cn(
              classes.clear,
              !iconSearch && classes.clear_plusMargin
            )}
            onClick={onClearSearch}
          >
            <Icon
              icon="closeCircle"
              className={classes.clear_icon}
              size="16px"
            />
          </div>
        )}
        {iconSearch && (
          <Icon icon={'search'} className={classes.search_icon} size="14px" />
        )}
      </div>
      {maxLength && visibleCounter && (
        <Text
          className={cn(percentMode && classes.search_percent, classes.counter)}
        >
          {value.length} / {maxLength}
        </Text>
      )}
    </>
  );
};

InputArea.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onClearSearch: PropTypes.func,
  value: PropTypes.string,
  iconSearch: PropTypes.bool,
  percentMode: PropTypes.bool,
  title: PropTypes.string,
  maxLength: PropTypes.number,
  modeTextArea: PropTypes.bool,
  required: PropTypes.bool,
  clearButton: PropTypes.bool,
  classNameScheme: PropTypes.object,
  visibleCounter: PropTypes.bool
};

export default InputArea;
